// General
import "./profile-about-me.scss";
import { useEffect } from "react";
// Services
import { useLazyGetProfileQuery } from "../../../../../services/data.service";
// Static Data
import editProfileConst from "../../../../../const/editProfileConst";
import userCardConst from "../../../../../const/userCardConst";
import routeConst from "../../../../../const/routeConst";
// Redux
import { useSelector, useDispatch } from "react-redux";
import {
  updateSmoking,
  updateDrinking,
  updateHeight,
  updateBodyType,
  updateEducation,
  updateRelationshipStatus,
  updatePosition,
  updateIndustry,
  updateChildren,
  updateEthnicity,
  updateRace,
  updateEyeColor,
  updateHairColor,
  updateUpdateProfileDialogView,
} from "../../../../../redux/store/editProfileStore";
import {
  updateRestartRegistrationDialog,
  updateUpdateProfileFullscreenDialog,
} from "../../../../../redux/store/dialogStore";
// react-gtm-module
import TagManager from "react-gtm-module";
// i18next
import { useTranslation, Trans } from "react-i18next";
// Custom Hooks
import IconManager from "../../../../utility/manager/icon-manager/icon-manager";
import useCustomNavigate from "../../../../utility/custom-hooks/useCustomNavigate-hook";

const ProfileAboutMe = () => {
  // API variables
  const [
    getProfile,
    {
      data: getProfileData,
      error: getProfileErrorData,
      isFetching: getProfileFetching,
      isLoading: getProfileLoading,
      isSuccess: getProfileSuccess,
      isError: getProfileError,
    },
  ] = useLazyGetProfileQuery();

  // Redux variables
  const aboutMeManualText = useSelector(
    (state) => state.userCard.aboutMeManualText
  );
  const aboutMeReadStatus = useSelector(
    (state) => state.userCard.aboutMeReadStatus
  );
  const smoking = useSelector((state) => state.userCard.smoking);
  const drinking = useSelector((state) => state.userCard.drinking);
  const height = useSelector((state) => state.userCard.height);
  const bodyType = useSelector((state) => state.userCard.bodyType);
  const education = useSelector((state) => state.userCard.education);
  const relationship = useSelector((state) => state.userCard.relationship);
  const position = useSelector((state) => state.userCard.position);
  const industry = useSelector((state) => state.userCard.industry);
  const children = useSelector((state) => state.userCard.children);
  const ethnicity = useSelector((state) => state.userCard.ethnicity);
  const race = useSelector((state) => state.userCard.race);
  const eyeColor = useSelector((state) => state.userCard.eyeColor);
  const hairColor = useSelector((state) => state.userCard.hairColor);
  const profileCompletionPercentage = useSelector(
    (state) => state.profile.profileCompletionPercentage
  );
  const profileRequirementPopup = useSelector(
    (state) => state.profile.profileRequirementPopup
  );
  const isSelf = useSelector((state) => state.userCard.isSelf);
  const ownMembershipType = useSelector((state) => state.user.membershipType);
  const dispatch = useDispatch();

  // i18next variables
  const { t } = useTranslation();

  // Custom Hooks Functions
  const getIcon = IconManager();
  const onNavigate = useCustomNavigate();

  // Lifecycle | Mounted
  useEffect(() => {
    getProfile(null, true);
  }, []);

  // Lifecycle | Check for update | getProfile API Response
  useEffect(() => {
    if (getProfileFetching || getProfileLoading) {
    } else if (getProfileSuccess) {
      // dispatch(
      //   updateProfileCompletionPercentage(
      //     getProfileData?.data?.profile_progress?.summary?.progress
      //   )
      // );
      dispatch(updateSmoking(getProfileData?.data?.habit?.smoking));
      dispatch(updateDrinking(getProfileData?.data?.habit?.drinking));
      dispatch(updateHeight(getProfileData?.data?.appearance?.height));
      dispatch(updateBodyType(getProfileData?.data?.appearance?.body_type));
      dispatch(updateEducation(getProfileData?.data?.occupation?.education));
      dispatch(
        updateRelationshipStatus(
          getProfileData?.data?.relationship?.relationship_status
        )
      );
      dispatch(updatePosition(getProfileData?.data?.occupation?.position));
      dispatch(updateIndustry(getProfileData?.data?.occupation?.industry));
      dispatch(updateChildren(getProfileData?.data?.relationship?.children));
      dispatch(updateEthnicity(getProfileData?.data?.appearance?.ethnicity));
      dispatch(updateRace(getProfileData?.data?.appearance?.race));
      dispatch(updateEyeColor(getProfileData?.data?.appearance?.eye_color));
      dispatch(updateHairColor(getProfileData?.data?.appearance?.hair_color));
    } else if (getProfileError) {
    }
  }, [
    getProfileFetching,
    getProfileLoading,
    getProfileSuccess,
    getProfileError,
  ]);

  // Event Handlers | Button
  const onEditSection = (section) => {
    if (isSelf) return;

    TagManager.dataLayer({
      dataLayer: {
        event: `PWA-64-64.2-${section}`,
      },
    });

    if (profileCompletionPercentage < profileRequirementPopup) {
      dispatch(updateRestartRegistrationDialog(true));
    } else {
      switch (section) {
        case editProfileConst.profileDialogView.smoking:
          dispatch(
            updateUpdateProfileDialogView(
              editProfileConst.profileDialogView.smoking
            )
          );
          break;
        case editProfileConst.profileDialogView.drinking:
          dispatch(
            updateUpdateProfileDialogView(
              editProfileConst.profileDialogView.drinking
            )
          );
          break;
        case editProfileConst.profileDialogView.height:
          dispatch(
            updateUpdateProfileDialogView(
              editProfileConst.profileDialogView.height
            )
          );
          break;
        case editProfileConst.profileDialogView.bodyType:
          dispatch(
            updateUpdateProfileDialogView(
              editProfileConst.profileDialogView.bodyType
            )
          );
          break;
        case editProfileConst.profileDialogView.education:
          dispatch(
            updateUpdateProfileDialogView(
              editProfileConst.profileDialogView.education
            )
          );
          break;
        case editProfileConst.profileDialogView.relationship:
          dispatch(
            updateUpdateProfileDialogView(
              editProfileConst.profileDialogView.relationship
            )
          );
          break;
        case editProfileConst.profileDialogView.occupation:
          dispatch(
            updateUpdateProfileDialogView(
              editProfileConst.profileDialogView.occupation
            )
          );
          break;
        case editProfileConst.profileDialogView.occupation:
          dispatch(
            updateUpdateProfileDialogView(
              editProfileConst.profileDialogView.occupation
            )
          );
          break;
        case editProfileConst.profileDialogView.children:
          dispatch(
            updateUpdateProfileDialogView(
              editProfileConst.profileDialogView.children
            )
          );
          break;
        case editProfileConst.profileDialogView.ethnicity:
          dispatch(
            updateUpdateProfileDialogView(
              editProfileConst.profileDialogView.ethnicity
            )
          );
          break;
        case editProfileConst.profileDialogView.race:
          dispatch(
            updateUpdateProfileDialogView(
              editProfileConst.profileDialogView.race
            )
          );
          break;
        case editProfileConst.profileDialogView.eyeColor:
          dispatch(
            updateUpdateProfileDialogView(
              editProfileConst.profileDialogView.eyeColor
            )
          );
          break;
        case editProfileConst.profileDialogView.hairColor:
          dispatch(
            updateUpdateProfileDialogView(
              editProfileConst.profileDialogView.hairColor
            )
          );
          break;
        default:
          break;
      }

      dispatch(updateUpdateProfileFullscreenDialog(true));
    }
  };
  const onUpgradeToRead = () => {
    TagManager.dataLayer({
      dataLayer: {
        event: "PWA-64-64.1",
      },
    });

    onNavigate(routeConst.upgrade.path);
  };

  // Utility Functions
  const returnAboutMeContent = () => {
    if (aboutMeReadStatus === userCardConst.aboutMeReadStatus.upgradeToRead) {
      return t("profile.about_me_placeholder");
    } else if (
      aboutMeReadStatus === userCardConst.aboutMeReadStatus.targetUserNotPremium
    ) {
      return t("profile.about_me_placeholder");
    } else {
      return aboutMeManualText;
    }
  };
  const returnIsBlur = () => {
    if (
      aboutMeReadStatus === userCardConst.aboutMeReadStatus.upgradeToRead ||
      aboutMeReadStatus === userCardConst.aboutMeReadStatus.targetUserNotPremium
    ) {
      return true;
    } else {
      return false;
    }
  };
  const returnShowUpgradeToRead = () => {
    if (aboutMeReadStatus === userCardConst.aboutMeReadStatus.upgradeToRead) {
      return true;
    } else {
      return false;
    }
  };
  const returnShowFreeSD = () => {
    if (
      aboutMeReadStatus === userCardConst.aboutMeReadStatus.targetUserNotPremium
    ) {
      return true;
    } else {
      return false;
    }
  };

  if (
    smoking ||
    drinking ||
    height ||
    bodyType ||
    education ||
    relationship ||
    position ||
    industry ||
    children ||
    children === 0
  ) {
    return (
      <div id="profile-about-me-subcomponent">
        <div className="padding-container">
          <div className="about-me-label">{t("profile.about_me")}</div>

          {(aboutMeManualText || aboutMeReadStatus) && (
            <div className="about-me-text-field-container">
              <div className="about-me-text">{returnAboutMeContent()}</div>

              {returnIsBlur() && <div className="blur-filter"></div>}

              {returnShowUpgradeToRead() && (
                <div className="upgrade-to-read-container">
                  <div className="upgrade-to-read-padding-container">
                    <div className="lock-icon-container">
                      {getIcon("goldLockIcon", "lock-icon")}
                    </div>

                    <div
                      className="upgrade-to-read-label"
                      onClick={onUpgradeToRead}
                    >
                      {t("profile.upgrade_to_read")}
                    </div>
                  </div>
                </div>
              )}

              {returnShowFreeSD() && (
                <div className="non-premium-container">
                  <div className="non-premium-title">
                    {t("profile.about_me_sd_free_title")}
                  </div>

                  <div className="non-premium-description">
                    <Trans
                      i18nKey={"profile.about_me_sd_free_desc"}
                      components={{ br: <br /> }}
                    />
                  </div>
                </div>
              )}
            </div>
          )}

          <div className="about-me-container">
            {smoking && (
              <div
                className={`about-me-item-container ${
                  isSelf ? "non-clickable" : ""
                }`}
                onClick={() => onEditSection("smoking")}
              >
                {getIcon("smokingIcon", "smoking-icon")}
                {smoking?.locale}
              </div>
            )}

            {drinking && (
              <div
                className={`about-me-item-container ${
                  isSelf ? "non-clickable" : ""
                }`}
                onClick={() => onEditSection("drinking")}
              >
                {getIcon("drinkingIcon", "drinking-icon")}
                {drinking?.locale}
              </div>
            )}

            {height && (
              <div
                className={`about-me-item-container ${
                  isSelf ? "non-clickable" : ""
                }`}
                onClick={() => onEditSection("height")}
              >
                {getIcon("heightIcon", "height-icon")}
                {height} cm
              </div>
            )}

            {bodyType && (
              <div
                className={`about-me-item-container ${
                  isSelf ? "non-clickable" : ""
                }`}
                onClick={() => onEditSection("bodyType")}
              >
                {getIcon("bodyTypeIcon", "body-type-icon")}
                {bodyType?.locale}
              </div>
            )}

            {ethnicity && (
              <div
                className={`about-me-item-container ${
                  isSelf ? "non-clickable" : ""
                }`}
                onClick={() => onEditSection("ethnicity")}
              >
                {getIcon("ethnicityIcon", "ethnicity-icon")}
                {ethnicity?.locale}
              </div>
            )}

            {race && (
              <div
                className={`about-me-item-container ${
                  isSelf ? "non-clickable" : ""
                }`}
                onClick={() => onEditSection("race")}
              >
                {race?.locale}
              </div>
            )}

            {eyeColor && (
              <div
                className={`about-me-item-container ${
                  isSelf ? "non-clickable" : ""
                }`}
                onClick={() => onEditSection("eyeColor")}
              >
                {getIcon("eyeColorIcon", "eye-color-icon")}
                {eyeColor?.locale}
              </div>
            )}

            {hairColor && (
              <div
                className={`about-me-item-container ${
                  isSelf ? "non-clickable" : ""
                }`}
                onClick={() => onEditSection("hairColor")}
              >
                {getIcon("hairColorIcon", "hair-color-icon")}
                {hairColor?.locale}
              </div>
            )}

            {education && (
              <div
                className={`about-me-item-container ${
                  isSelf ? "non-clickable" : ""
                }`}
                onClick={() => onEditSection("education")}
              >
                {getIcon("educationIcon", "education-icon")}
                {education?.locale}
              </div>
            )}

            {relationship && (
              <div
                className={`about-me-item-container ${
                  isSelf ? "non-clickable" : ""
                }`}
                onClick={() => onEditSection("relationship")}
              >
                {getIcon("relationshipIcon", "relationship-icon")}
                {relationship?.locale}
              </div>
            )}

            {position && (
              <div
                className={`about-me-item-container ${
                  isSelf ? "non-clickable" : ""
                }`}
                onClick={() => onEditSection("occupation")}
              >
                {getIcon("occupationIcon", "education-icon")}
                {position?.locale}
                {industry?.locale ? `, ${industry?.locale}` : ""}
              </div>
            )}

            {(children || children !== 0) && (
              <div
                className={`about-me-item-container ${
                  isSelf ? "non-clickable" : ""
                }`}
                onClick={() => onEditSection("children")}
              >
                {getIcon("kidsIcon", "children-icon")}
                {children} {t("profile.children")}
              </div>
            )}

            {children === 0 && (
              <div
                className={`about-me-item-container ${
                  isSelf ? "non-clickable" : ""
                }`}
                onClick={() => onEditSection("children")}
              >
                {getIcon("kidsIcon", "children-icon")}
                {t("profile.dont_have_kids")}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
};

export default ProfileAboutMe;
